module.exports = __webpack_public_path__ + "img/技术需求库banner.8e3c4756.png";